export default "__VITE_ASSET__DSM1RTsq__"